import { FORMAT_DATE_TIME_DAYJS } from 'constants/common'
import dayjs, { Dayjs } from 'dayjs'

export const convertDayToSecondsTime = (day: Dayjs) => {
  const time = dayjs(day).format(FORMAT_DATE_TIME_DAYJS)
  const date = new Date(time)
  return date.getTime() / 1000
}
